<template>
  <div class="bg-white rounded-circle p-1">
    <em class="rounded-circle bg-orange text-white p-2" :class="i" />
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    i: {
      type: String,
      required: true,
    },
  },
};
</script>
